import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DesktopToaster {
  desktopToaster$ = new BehaviorSubject<Toaster>(null!);
}

interface Toaster {
  severity: string,
  summary: string,
  detail: string,
  appear?: boolean,
  bar?: boolean
}